import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import InputNum from "../InputNum/InputNum";
import TitleNode from "./TitleNode/TitleNode";
import { Row, Col } from 'antd';
import { tree } from "../../../../../../../../utils/operations";
import FlowCard from "./FlowCard/FlowCard";
import genFieldNomenclature from "../../../../../../../../utils/genFieldNomenclature";
import formatter from "../../../../../../../../utils/formatter";
import UpArrow from "../../../../../../../../assets/icons/caret-up.png";
import DownArrow from "../../../../../../../../assets/icons/caret-down.png";
import { updateFromTotal, updateFromFormField, clearFormData } from "../../../../actions";
import { DataValue, InvestmentOption, DisplayMobFooter, Total } from "./styles";
import { TotalSpan, TotalPercentDiv, Triangle } from '../InvestmentTable/styles';
import { RecommendAnExchangeAPIs } from '../../../../../../../../services/drupalServices';
import FundModal from "../../../../../../../Investments/Pages/RecommendAnExchangeNew/components/exchangeTo/FundModal";
import { recordError } from "../../../../../../../../utils/commonUtil";
import { investmentAllocationCardState } from "../../../../selectors";
import { replaceSelect } from "../../../../../../../../utils/replacer";

let fundData = [];
let underlyingFundData = [];
let isPoolModal = false;
let rowFieldCount = -1;

export class InvestmentAllocationCard extends Component {

  constructor(props) {
    super(props);
    this.renderTitleGrid = this.renderTitleGrid.bind(this);
    this.renderFixGrid = this.renderFixGrid.bind(this);
    this.renderInputBox = this.renderInputBox.bind(this);
    this.clearData = this.clearData.bind(this);
    this.showPoolDetails = this.showPoolDetails.bind(this);
    this.closePoolInfo = this.closePoolInfo.bind(this);
    this.renderTitleGrid = this.renderTitleGrid.bind(this);
  }

  setPoolData = (responses) => {
    fundData = responses[0].data;
    underlyingFundData = responses[1].data;
    isPoolModal = true;
    this.setState({poolPopUp: true});
  }

  closePoolInfo = () => {
    underlyingFundData = [];
    fundData = [];
    isPoolModal = false;
    this.setState({poolPopUp: false})
  }

  showPoolDetails = (value) => {
    try {
      const promises = [];
      let poolName = value.replace(' Select','');
      promises.push(RecommendAnExchangeAPIs.getInvestmentFunds({ value:poolName}));
      promises.push(RecommendAnExchangeAPIs.getInvestmentUnderlyingFunds({ value:poolName }));
      Promise.all(promises).then((responses) => {
        this.setPoolData(responses);
      });
    } catch (error) {
      recordError(error);
    }
  }

  renderTitleGrid(pool) {
    return <InvestmentOption onClick={(e) => this.showPoolDetails(pool.investmentOption)}>{replaceSelect(pool.investmentOption)}</InvestmentOption>;
  }

  renderFixGrid({ pool, gridName, poolName }) {
    return (
      <>
        <TitleNode title={poolName} />
        <DataValue>
          { pool[gridName] ? 
          ((gridName === 'availableBalance' || gridName === "currentNav")
              ? <span> {formatter({ value: pool[gridName], fieldSuffix: 'Dollars' })} {gridName === 'currentNav' ? <Triangle alt={(pool['rise'] === false || pool['rise'] === 'false' ) ? 'fall' : 'rise'} src={(pool['rise'] === false || pool['rise'] === 'false' ) ? DownArrow : UpArrow} /> : ''} </span>
              : pool[gridName])
            : <div>&mdash;</div> }
        </DataValue>  
      </>
    );
  }

  renderInputBox(pool, index) {
    rowFieldCount += 1;

    const fieldSuffixArr = ['Percentage'];
    const nomenclatureObj = genFieldNomenclature({
      fieldSuffixArr,
      fieldName: pool.investmentOption,
      rowFieldCount,
    });

    const stuff = tree(
        'Percentage',
      );

    return (
      <>
        <TitleNode title="Percentage" />
        <InputNum
          updateFormFields={updateFromFormField}
          updateTotal={updateFromTotal}
          fieldInfoObj={{
            ...nomenclatureObj,
            stuff,
          }}
          investmentOption={this.props.investmentOption}
        />
      </>
    );
  }

   styleConfig() {
    return {
      alternatingBg: true,
      cardBorder: false,
      cardDivider: true,
      cardPadding: true,
    };
  }

   destObj(pool, index) {
    return [
      {
        name: 'investmentOption',
        gridWidth: '100',
        type: 'TitleGrid',
        render: this.renderTitleGrid(pool),
        noBorderBottom: true,
        ptop: true,
      },
      {
        name: 'availableBalance',
        gridWidth: '50',
        type: 'FixGrid',
        render: this.renderFixGrid({ pool, gridName: 'availableBalance', poolName: 'availableBalance' }),
        ptop: true,
        pbottom: true,
        pright: true,
      },
      {
        name: 'pricePerUnit',
        gridWidth: '50',
        type: 'FixGrid',
        render: this.renderFixGrid({ pool, gridName: 'currentNav', poolName: 'pricePerUnit' }),
        ptop: true,
        pbottom: true,
        pright: true,
      },
      {
        name: 'Percentage',
        type: 'Input',
        gridWidth: '100',
        render: this.renderInputBox(pool, index),
        ptop: true,
        pbottom: true,
        pleft: true,
      }
    ];
  }

  clearData = () => {
    this.props.clearFormData();
  }

render(){
  return (
    <>
      {this.props.accountData[this.props.investmentOption] && this.props.accountData[this.props.investmentOption].map((pool, index) => (
        <FlowCard
          cardConfig={this.destObj(pool, index)}
          styleConfig={this.styleConfig()}
          index={index}
          scrollId="fromFlowCard"
        />
      ))}
      {
        this.props.investmentOption === "valueDriven" ?
        <DisplayMobFooter>
      <Row type="flex">
        
          <Col>
            <Total>Total</Total>
          </Col> 
         
          <Col>
            <InvestmentOption className={this.props.totalValue > 0 ? "block" : "display-none" } data-test='inv-option' onClick={this.clearData.bind(this)}>Clear All</InvestmentOption>
            
         </Col>
          <Col>
            <TotalSpan>{this.props.totalValue}.00%</TotalSpan>
            <TotalPercentDiv>of 100%</TotalPercentDiv>
          </Col>
       
      </Row>
      </DisplayMobFooter>
      : ""
      }
       <FundModal
          data-test='fund-modal'
          visible={isPoolModal}
          poolUf={underlyingFundData}
          poolData={fundData}
          cancelOptionModal={() => this.closePoolInfo()}
        />
    </>
  );
}
}

InvestmentAllocationCard.propTypes = {
  accountData: PropTypes.object,
  dummyData: PropTypes.bool,
  totalValue: PropTypes.string,
  updateFromTotal: PropTypes.func,
  clearFormData: PropTypes.func,
}

const mapStateToProps = state => ({
    ...investmentAllocationCardState(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  updateFromTotal: reset => dispatch(updateFromTotal(reset)),
  clearFormData: () => dispatch(clearFormData())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InvestmentAllocationCard);
